import { useGlobalContext } from "@/context/global/GlobalContext";

const FeedFilterDropdown = ({ onChange }) => {
  const { filter, setFilter, showDropdown, setShowDropdown } = useGlobalContext();
  const handleSelect = (option) => {
    setFilter(option);
    setShowDropdown(false);
    onChange(option);
  };

  return (
    <>
      {showDropdown && (
        <div className="ml-4">
          <div className="absolute left-4 mt-2 w-40 rounded-xl drop-shadow-lg p-1 border dark:border-neutral-800 dark:bg-neutral-900 bg-dark_primary_label z-50">
            <button
              onClick={() => handleSelect("all")}
              className={`block w-full text-left px-4 py-2 hover:bg-light_bg_grey  dark:hover:bg-brown ${filter === "all" && "bg-light_bg_grey dark:bg-brown"}`}
            >
              All
            </button>
            <button
              onClick={() => handleSelect("following")}
              className={`block w-full text-left px-4 py-2 hover:bg-light_bg_grey  dark:hover:bg-brown ${filter === "following" && "bg-light_bg_grey dark:bg-brown"}`}
            >
              Following
            </button>
            <button
              onClick={() => handleSelect("favorites")}
              className={`block w-full text-left px-4 py-2 hover:bg-light_bg_grey  dark:hover:bg-brown ${filter === "favorites" && "bg-light_bg_grey dark:bg-brown"}`}
            >
              Favorites
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedFilterDropdown;
